// src/reducers/medicineReducers.js

import {
  MED_SEARCH_REQUEST,
  MED_SEARCH_SUCCESS,
  MED_SEARCH_FAIL,
  LOWSTOCK_REQUEST,
  LOWSTOCK_SUCCESS,
  LOWSTOCK_FAIL,
  SALE_REQUEST,
  SALE_SUCCESS,
  SALE_FAIL,
  PRESCRIPTION_REQUEST, // ✅ NEW
  PRESCRIPTION_SUCCESS, // ✅ NEW
  PRESCRIPTION_FAIL, // ✅ NEW
  PRESCRIPTION_CLEAR,
} from "../../constants/pharmacistConstants/pharmacistConstants";

const initialState = {
  medsSearch: { loading: false, meds: [], error: null },
  lowStock: { loading: false, meds: [], error: null },
  sale: { loading: false, sale: null, error: null },
  prescription: { // ✅ NEW: Prescription state
    data: null,
    loading: false,
    error: null,
    found: false
  }

};

export const pharmacistReducer = (state = initialState, action) => {
  switch (action.type) {
    // --- Medicine Search ---
    case MED_SEARCH_REQUEST:
      return { ...state, medsSearch: { ...state.medsSearch, loading: true } };
    case MED_SEARCH_SUCCESS:
      return {
        ...state,
        medsSearch: { loading: false, meds: action.payload, error: null },
      };
    case MED_SEARCH_FAIL:
      return {
        ...state,
        medsSearch: { loading: false, meds: [], error: action.payload },
      };

    // --- Low Stock ---
    case LOWSTOCK_REQUEST:
      return { ...state, lowStock: { ...state.lowStock, loading: true } };
    case LOWSTOCK_SUCCESS:
      return {
        ...state,
        lowStock: { loading: false, meds: action.payload, error: null },
      };
    case LOWSTOCK_FAIL:
      return {
        ...state,
        lowStock: { loading: false, meds: [], error: action.payload },
      };

    // --- Sale ---
    case SALE_REQUEST:
      return { ...state, sale: { ...state.sale, loading: true } };
    case SALE_SUCCESS:
      return {
        ...state,
        sale: { loading: false, sale: action.payload, error: null },
      };
    case SALE_FAIL:
      return {
        ...state,
        sale: { loading: false, sale: null, error: action.payload },
      };
    // ✅ NEW: Prescription reducer cases
    case PRESCRIPTION_REQUEST:
      return {
        ...state,
        prescription: { 
          ...state.prescription, 
          loading: true, 
          error: null,
          found: false
        }
      };
    case PRESCRIPTION_SUCCESS:
      return {
        ...state,
        prescription: {
          data: action.payload,
          loading: false,
          error: null,
          found: action.payload.found
        }
      };
    case PRESCRIPTION_FAIL:
      return {
        ...state,
        prescription: {
          data: null,
          loading: false,
          error: action.payload,
          found: false
        }
      };
    case PRESCRIPTION_CLEAR:
      return {
        ...state,
        prescription: {
          data: null,
          loading: false,
          error: null,
          found: false
        }
      };  
    default:
      return state;
  }
};
